import type { ModerationDocumentKind } from '@/contracts';

export type KindFilter = 'all' | ModerationDocumentKind;

export const KIND_FILTERS: readonly KindFilter[] = ['all', 'credential', 'video_intro'];

/** The kind chip lives in `?documentKind=`, so the review screen's back link can restore it. */
export function parseDocumentKind(value: string | null): KindFilter {
  return value === 'credential' || value === 'video_intro' ? value : 'all';
}
